import MChip from "@mui/material/Chip";
import PropTypes from "prop-types";

const colorMap = {
  draft: "default",
  active: "info",
  on_hold: "warning",
  complete: "success",
  shipped: "secondary",
  published: "success",
  in_review: "warning",
  archived: "default",
  pending: "default",
  in_progress: "info",
  blocked: "warning",
  passed: "success",
  failed: "error",
};

export default function StatusChip({ value, size = "small" }) {
  const color = colorMap[value] || "default";
  return (
    <MChip
      size={size}
      label={value}
      color={color}
      variant={color === "default" ? "outlined" : "filled"}
    />
  );
}

StatusChip.propTypes = {
  value: PropTypes.string,
  size: PropTypes.oneOf(["small", "medium"]),
};

